import { render, staticRenderFns } from "./resourceModal.vue?vue&type=template&id=49a2f2a6&scoped=true&"
import script from "./resourceModal.vue?vue&type=script&lang=js&"
export * from "./resourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2f2a6",
  null
  
)

export default component.exports